const useStyles = {
  container: {
    flexDirection: 'column',
    gap: 2,
    marginTop: 2,
    alignItems: 'center',
  },
}

export default useStyles
